import Image from "next/image"
import LogomarkBlack from "app/design_system/wordmark_black.svg"
import LogomarkIvory from "app/design_system/logomark_ivory.svg"

import { cn } from "@/lib/utils"

interface LogoProps {
  className?: string
  wrapperClassName?: string
  variant?: "wood" | "ivory" | "black" | "white"
}

export function Logo({ wrapperClassName, className, variant }: LogoProps) {
  return (
    <div className={wrapperClassName}>
      <Image
        src={LogomarkBlack}
        alt="Paragraph"
        className={cn("md:w-full  w-10 dark:hidden h-10", className)}
      />
      <Image
        src={LogomarkIvory}
        alt="Paragraph"
        className={cn(
          "md:w-full h-auto w-10 hidden dark:block max-h-10",
          className
        )}
      />
    </div>
  )
}
